import type { Theme } from '@mui/material';
import { Chip, Typography, chipClasses, styled } from '@mui/material';
import { deepPurple, grey, pink, purple } from '@mui/material/colors';

interface LookoBadgeProps {
  /**
   * 칩 텍스트.
   */
  label: React.ReactNode;

  /**
   * @deprecated color 로 변경.
   * @default 'primary'
   */
  variant?:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'red1'
    | 'red2'
    | 'green'
    | 'purple'
    | 'gray1'
    | 'gray2'
    | 'white'
    | 'orange';

  /**
   * 색상.
   *
   * @default 'primary'
   */
  color?:
    | 'primary'
    | 'secondary'
    | 'tertiary'
    | 'red1'
    | 'red2'
    | 'green'
    | 'purple'
    | 'gray1'
    | 'gray2'
    | 'white'
    | 'orange';
}

const styleMap = (theme: Theme): Record<NonNullable<LookoBadgeProps['color']>, React.CSSProperties> => {
  return {
    primary: {
      background: theme.palette.primary.main,
      color: theme.palette.primary.contrastText,
    },
    secondary: {
      background: '#E4F2FD',
      color: theme.palette.primary.main,
    },
    tertiary: {
      background: grey[500],
      color: 'white',
    },
    red1: {
      background: theme.palette.error.light,
      color: 'white',
    },
    red2: {
      background: pink[50],
      color: theme.palette.error.light,
    },
    green: {
      background: theme.palette['chip.green'].main,
      color: theme.palette['chip.green'].contrastText,
    },
    purple: {
      background: deepPurple[50],
      color: purple[700],
    },
    gray1: {
      background: grey[50],
      color: grey[500],
    },
    gray2: {
      background: grey[200],
      color: grey[500],
    },
    white: {
      background: 'white',
      color: theme.palette.primary.main,
    },
    orange: {
      background: '#FFECB3',
      color: '#FF6F00',
    },
  };
};

/**
 * Badge 컴포넌트.
 */
export const LookoBadge = styled(({ label, color, variant, ...props }: LookoBadgeProps) => {
  return <Chip className="LookoBadge" label={<Typography variant="caption">{label}</Typography>} {...props} />;
})(({ theme, color = 'primary', variant }) => {
  return {
    height: 20,
    [`& .${chipClasses.label}`]: {
      paddingLeft: 6.5,
      paddingRight: 6.5,
    },

    ...styleMap(theme)[variant ?? color],
  };
});
